const InvoiceStatuses = {
  INVOICE_STATUS_CREATED: '0',
  INVOICE_STATUS_SENT: '1',
  INVOICE_STATUS_PAID: '2',
  INVOICE_STATUS_VOID: '3',
  INVOICE_STATUS_DELETED: '4'
};

InvoiceStatuses.install = function (Vue) {
    Vue.prototype.$getConstInvoiceStatus = (key) => {
        return InvoiceStatuses[key];
    }
}

export default InvoiceStatuses;
